import NBType from '@netbase/nb-type'

/**
 * @typedef {object} LogoSettingSchema
 * @property {number} createDate
 * @property {number} high
 * @property {number} id
 * @property {string} logo
 * @property {number} low
 * @property {number} med
 * @property {number} updateDate
 */
const LogoSettingSchema = NBType.object().shape('LogoSettingSchema', {
  /* @prop */
  createDate: NBType.timestamp().nullable(),
  /* @prop */
  high: NBType.number(),
  /* @prop */
  id: NBType.number(),
  /* @prop */
  logo: NBType.string(),
  /* @prop */
  low: NBType.number(),
  /* @prop */
  med: NBType.number(),
  /* @prop */
  updateDate: NBType.timestamp().nullable()
  /* END */
})
export default LogoSettingSchema
// RESERVE BELOW
